// extracted by mini-css-extract-plugin
module.exports = {"ClaraSwitchButton":"ClaraSwitchButton_ClaraSwitchButton__1AfG1","SelectedBLUE":"ClaraSwitchButton_SelectedBLUE__2tCjD"};